__turbopack_context__.v({
  "topicTeaser": "TopicTeaser-module-scss-module__KRzxwW__topicTeaser",
  "topicTeaserContent": "TopicTeaser-module-scss-module__KRzxwW__topicTeaserContent",
  "topicTeaserContentWrapper": "TopicTeaser-module-scss-module__KRzxwW__topicTeaserContentWrapper",
  "topicTeaserImage": "TopicTeaser-module-scss-module__KRzxwW__topicTeaserImage",
  "topicTeaserTitle": "TopicTeaser-module-scss-module__KRzxwW__topicTeaserTitle",
});
